<div class="phx-action-row-container" #container>
  <ng-content></ng-content>

  <phx-menu-button
    *ngIf="showOverflowButton"
    [phxButtonRole]="'secondary'"
    [phxDropdownTemplate]="overflowDropdown"
    [phxDropdownPosition]="'bottomRight'"
    [phxSuffixIcon]="ellipsesIcon"
  >
  </phx-menu-button>

  <phx-dropdown #overflowDropdown>
    <phx-menu class="phx-overflow-menu">
      <phx-menu-item 
        *ngFor="let item of overflowItems"
        [disabled]="item.disabled"
        (click)="item.clickHandler()"
        (keydown.enter)="item.clickHandler()"
        (keydown.space)="item.clickHandler()"
        >
        {{ item.buttonText }}
      </phx-menu-item>
    </phx-menu>
  </phx-dropdown>
</div>
